(() => {
  'use strict';

  if (window.__headerMetaSliderBootstrapped) {
    window.HeaderMetaSliderInit?.();
    return;
  }
  window.__headerMetaSliderBootstrapped = true;

  const inited = new WeakSet();

  const initRoot = (root) => {
    if (!root || inited.has(root)) return;

    const track = root.querySelector('[data-header-meta-track]');
    if (!track) return;

    const realSlides = Array.from(track.children).filter(
      (slide) => !slide.hasAttribute('data-header-meta-clone')
    );
    if (realSlides.length < 2) return;

    inited.add(root);

    // Remove previous clones (theme editor re-init)
    track.querySelectorAll('[data-header-meta-clone]').forEach((clone) => clone.remove());

    const firstClone = realSlides[0].cloneNode(true);
    firstClone.setAttribute('data-header-meta-clone', 'true');
    firstClone.setAttribute('aria-hidden', 'true');
    track.appendChild(firstClone);

    const total = realSlides.length; // real count; clone is total index
    let index = 0;
    let timer = null;
    let animating = false;
    const delay = Number(root.dataset.autoplay || 3500);

    const setTransform = (i, animate) => {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = `translate3d(-${i * 100}%, 0, 0)`;
    };

    const goNext = () => {
      if (animating) return;
      animating = true;
      index += 1;
      setTransform(index, true);

      if (index === total) {
        const onEnd = (event) => {
          if (event.propertyName !== 'transform') return;
          track.removeEventListener('transitionend', onEnd);
          // Jump back to real first slide without animation
          setTransform(0, false);
          // Force reflow so next transition works
          void track.offsetHeight;
          track.style.transition = '';
          index = 0;
          animating = false;
        };
        track.addEventListener('transitionend', onEnd);
      } else {
        const onEnd = (event) => {
          if (event.propertyName !== 'transform') return;
          track.removeEventListener('transitionend', onEnd);
          animating = false;
        };
        track.addEventListener('transitionend', onEnd);
      }
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      timer = window.setInterval(goNext, delay);
    };

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) start();
    });

    setTransform(0, false);
    start();
  };

  const initAll = () => {
    document.querySelectorAll('[data-header-meta-slider]').forEach((root) => initRoot(root));
  };

  window.HeaderMetaSliderInit = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector?.('[data-header-meta-slider]')) {
      initAll();
    }
  });
})();
